import {
    AppBar,
    Box,
    IconButton,
    Link,
    Toolbar,
    Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import MobileMenu from "./mobile-header-menu";
import DesktopMenu from "./desktop-header-menu";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const menuItems = [
    { label: "Главная", path: "/" },
    { label: "О питомнике", path: "/about" },
    { label: "Питомцы", path: "/pets" },
];

export default function Header() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDrawer = (open: boolean) => () => {
        setMobileOpen(open);
    };

    return (
        <Box sx={{ minHeight: { xs: 64, md: 72 } }}>
            <AppBar position="fixed" color="primary" elevation={0}>
                <Toolbar
                    sx={{
                        minHeight: { xs: 64, md: 72 },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 1,
                        px: { xs: 1, sm: 2 },
                    }}
                >
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={toggleDrawer(true)}
                        sx={{ display: { md: "none" }, mr: 0.5 }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            flexDirection: { xs: "column", md: "row" },
                            alignItems: { xs: "center", md: "stretch" },
                        }}
                    >
                        <Typography
                            variant="h6"
                            component="div"
                            onClick={() => navigate("/")}
                            sx={{
                                fontWeight: 700,
                                fontSize: { xs: "1.1rem", md: "1.25rem" },
                                letterSpacing: { xs: "2px", md: "4px" },
                                textTransform: "uppercase",
                                flexGrow: 1,
                                cursor: "pointer",
                                textAlign: { xs: "center", md: "left" },
                                display: "flex",
                                alignItems: "center",
                                "&:hover": { opacity: 0.9 },
                            }}
                        >
                            Питомник Миф и реальность
                        </Typography>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: { xs: 1, md: 2 },
                                flexWrap: "wrap",
                                justifyContent: { xs: "center", md: "flex-end" },
                            }}
                        >
                            <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
                                <DesktopMenu menuItems={menuItems} />
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    ml: { md: 2 },
                                    minWidth: 0,
                                    flexDirection: "column",
                                }}
                            >
                                <Typography variant="body2" color="inherit" noWrap>
                                    ИП Шамовнева Татьяна Михайловна
                                </Typography>
                                <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 1 }}>
                                    <Link href="tel:+7(918)081-80-23" color="inherit" underline="none">
                                        +7(918)081-80-23
                                    </Link>
                                    <Link href="mailto:shamovneva74@bk.ru" color="inherit" underline="none">
                                        shamovneva74@bk.ru
                                    </Link>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>

            <MobileMenu
                menuItems={menuItems}
                mobileOpen={mobileOpen}
                setMobileOpen={setMobileOpen}
                toggleDrawer={toggleDrawer}
            />
        </Box>
    );
}
